export const timelineFormat = "yyyy-MM-dd HH:mm";

export const init = ({
  ref,
  defaultDate,
  y_unit,
  lightbox_sections = [],
  days,
  view,
}) => {
  const scheduler = window.Scheduler.getSchedulerInstance();

  scheduler.skin = "material";
  scheduler.config.header = [];

  // set the 1st day of the week
  scheduler.config.start_on_monday = true;

  // create a timeline in the scheduler
  scheduler.createTimelineView({
    name: "timeline-hours",
    x_unit: "minute",
    x_date: "%H:%i",
    x_step: 120,
    x_size: 84,
    x_start: 0,
    x_length: 84,
    y_unit: y_unit,
    y_property: "userId",
    // render: "bar",
    render: "tree",
    dy: 30,
    section_autoheight: false,
    scrollable: true,
    column_width: 70,
    scroll_position: defaultDate,
    second_scale: {
      x_unit: "day", // the measuring unit of the axis (by default, 'minute')
      x_date: "%l %d %F", //the date format of the axis ("July")
    },
  });

  scheduler.createTimelineView({
    name: "timeline-days",
    x_unit: "day",
    x_date: "%d",
    x_step: 1,
    x_size: days,
    x_start: 0,
    x_length: days,
    y_unit: y_unit,
    y_property: "userId",
    // render: "bar",
    render: "tree",
    dy: 30,
    section_autoheight: false,
    scrollable: true,
    column_width: 70,
    scroll_position: defaultDate,
    second_scale: {
      x_unit: "month", // the measuring unit of the axis (by default, 'minute')
      x_date: "%F", //the date format of the axis ("July")
    },
  });

  scheduler.config.lightbox.sections = lightbox_sections;
  scheduler.config.readonly_form = true;

  scheduler.config.collision_limit = 1;

  scheduler.config.readonly = true;

  scheduler.init(ref, defaultDate, view);
  return scheduler;
};
